import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { NzInputNumberComponent } from "ng-zorro-antd/input-number";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiSizeLDSType } from "@webapp/ui/core/models/ui-size.models";

@Component({
  selector: "ui-input-number",
  exportAs: "uiInputNumber",
  templateUrl: "input-number.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiInputNumberComponent),
      multi: true,
    },
  ],
})
export class UiInputNumberComponent extends NzInputNumberComponent {
  @Input("uiSize")
  public nzSize: UiSizeLDSType = "default";
  @Input("uiMin")
  public nzMin = -Infinity;
  @Input("uiMax")
  public nzMax = Infinity;
  @Input("uiParser")
  public nzParser = (value: string): string =>
    value
      .trim()
      .replace(/。/g, ".")
      .replace(/[^\w.-]+/g, "");
  @Input("uiPrecision")
  public nzPrecision?: number;
  @Input("uiPrecisionMode")
  public nzPrecisionMode: "cut" | "toFixed" | ((value: number | string, precision?: number) => number) = "toFixed";
  @Input("uiPlaceHolder")
  public nzPlaceHolder = "";
  @Input("uiStep")
  public nzStep = 1;
  @Input("uiInputMode")
  public nzInputMode = "decimal";
  @Input("uiId")
  public nzId: string | null = null;
  @Input("uiDisabled")
  @InputBoolean()
  public nzDisabled = false;
  @Input("uiAutoFocus")
  @InputBoolean()
  public nzAutoFocus = false;
  @Input("uiFormatter")
  public nzFormatter: (value: number) => string | number = (value) => value;

  @Output("uiBlur")
  public readonly nzBlur = new EventEmitter();
  @Output("uiFocus")
  public readonly nzFocus = new EventEmitter();

  @ViewChild("inputElement", { static: true })
  public inputElement!: ElementRef<HTMLInputElement>;
}
